import { FormGroup, Validators } from '@angular/forms';

import { ServiceTicketValidationAction } from './service-ticket-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';
import { requiredWith, updateValidity } from 'app/validators';

export class ServiceTicketRules extends FormModel<ServiceTicketValidationAction> {
    baseValidators: FieldValidatorsMap = {
        service: [Validators.required],
        amountAvailable: [Validators.min(0)],
        dateLimitation: [],
        daysLimitation: [Validators.min(0), requiredWith(['ticketsOnline'])],
        durationDays: [Validators.min(0), requiredWith(['durationDaysToggle'])],
        durationDaysToggle: [updateValidity(['ticketsOnline'])],
        expiresAtToggle: [updateValidity(['ticketsOnline'])],
        ticketName: [Validators.required],
        price: [Validators.required, Validators.min(0)],
        sportIdPrice: [Validators.min(0)],
        expiresAt: [requiredWith(['expiresAtToggle'])],
        purchasableFrom: [],
        purchasableUntil: [],
        ticketsOnline: [],
    };
    formValidators: FormValidatorsMap = {};

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(ServiceTicketValidationAction.Store, formFrom);
    }

    getUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(ServiceTicketValidationAction.Update, formFrom);
    }
}
